"use client"

import { useEffect, useState } from "react"
import API from "../services/api"
import "./SeminaireClient.css"

const SeminairesClient = () => {
  const [seminaires, setSeminaires] = useState([])
  const [selectedSeminaire, setSelectedSeminaire] = useState(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isLoaded, setIsLoaded] = useState(false)

  const fetchSeminaires = async () => {
    try {
      const res = await API.get("/seminaires")
      setSeminaires(res.data)
      if (res.data.length > 0) {
        setSelectedSeminaire(res.data[0])
      }
      setIsLoaded(true)
    } catch (error) {
      console.error("Erreur chargement des séminaires:", error)
    }
  }
const [showModal, setShowModal] = useState(false)
const [reservationData, setReservationData] = useState({
  name: "",
  email: "",
  phoneNumber: "",
  from: "",
  to: new Date().toISOString().split("T")[0],
  people: 1
})
const handleReservationSubmit = async () => {
  try {
    const payload = {
      ...reservationData,
      service: "seminaire",
      serviceDetails: selectedSeminaire?.nom || "",
      status: "pending"
    }

    await API.post("/reservations", payload)
    alert("Réservation créée avec succès !")
    setShowModal(false)
    setReservationData({
      name: "",
      email: "",
      phoneNumber: "",
      from: "",
      to: new Date().toISOString().split("T")[0],
      people: 1
    })
  } catch (error) {
    console.error("Erreur de réservation:", error)
    alert("Erreur lors de la création de la réservation.")
  }
}

  useEffect(() => {
    fetchSeminaires()

    // Force a re-render after a short delay to ensure visibility
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  const handleNext = () => {
    if (seminaires.length === 0) return
    const nextIndex = (currentIndex + 1) % seminaires.length
    setCurrentIndex(nextIndex)
    setSelectedSeminaire(seminaires[nextIndex])
  }

  const handlePrevious = () => {
    if (seminaires.length === 0) return
    const prevIndex = (currentIndex - 1 + seminaires.length) % seminaires.length
    setCurrentIndex(prevIndex)
    setSelectedSeminaire(seminaires[prevIndex])
  }

  const handleSelectSeminaire = (seminaire, index) => {
    setSelectedSeminaire(seminaire)
    setCurrentIndex(index)
  }

  return (
    <div className="hotel-app8">
      <header className="app-header">
        <a href="/SolutionHotel/Home" className="header-back-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 12H5M5 12L12 19M5 12L12 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Retour
        </a>
        <div className="logo-container">
          <img src="/SolutionHotel/images/logo2.png" alt="Hotel Logo" className="logo" />
        </div>
        <div></div> {/* Empty div for flex spacing */}
      </header>

      <main className="app-main">
        <div className="welcome-banner">
          <h1>
            <span>Espaces</span> Séminaires
          </h1>
          <p>Découvrez nos espaces professionnels pour vos événements d'entreprise</p>
        </div>

        <div className="content-container">
          {selectedSeminaire ? (
            <div className="seminaire-detail-container">
              <div className="seminaire-navigation">
                <button className="nav-button prev-button" onClick={handlePrevious} disabled={seminaires.length <= 1}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15 18L9 12L15 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div className="seminaire-counter">
                  {currentIndex + 1} / {seminaires.length}
                </div>
                <button className="nav-button next-button" onClick={handleNext} disabled={seminaires.length <= 1}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 18L15 12L9 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div className="seminaire-detail-content">
                <div className="seminaire-image-container">
                  <img
                    src={selectedSeminaire.image || "/placeholder.svg"}
                    alt={selectedSeminaire.nom}
                    className="seminaire-image"
                    onError={(e) => {
                      e.target.src = `/placeholder.svg?height=300&width=500&text=${selectedSeminaire.nom}`
                    }}
                  />
                </div>
                <div className="seminaire-info">
                  <h2 className="seminaire-name">{selectedSeminaire.nom}</h2>

                  <div className="seminaire-specs">
                    <div className="spec-item">
                      <div className="spec-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="spec-content">
                        <div className="spec-label">Capacité</div>
                        <div className="spec-value">{selectedSeminaire.capacite} personnes</div>
                      </div>
                    </div>

                    <div className="spec-item">
                      <div className="spec-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3 9H21"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9 21V9"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="spec-content">
                        <div className="spec-label">Superficie</div>
                        <div className="spec-value">{selectedSeminaire.superficie} m²</div>
                      </div>
                    </div>

                    <div className="spec-item">
                      <div className="spec-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M8 2H16"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 16V9"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5 8H19"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3 12H21"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4 16H20"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M6 20H18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="spec-content">
                        <div className="spec-label">Hauteur sous plafond</div>
                        <div className="spec-value">{selectedSeminaire.hauteur} m</div>
                      </div>
                    </div>
                  </div>

                  <div className="seminaire-description">
                    {selectedSeminaire.description ||
                      "Cet espace de séminaire est parfaitement équipé pour accueillir vos événements professionnels dans un cadre élégant et fonctionnel."}
                  </div>

                  <div className="seminaire-features">
                    <div className="feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Équipement audiovisuel</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Wi-Fi haut débit</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Climatisation</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">✓</span>
                      <span>Service de restauration</span>
                    </div>
                  </div>

                  <div className="seminaire-actions">
<button className="reserve-button" onClick={() => setShowModal(true)}>RÉSERVER UNE SALLE</button>
                    {selectedSeminaire.fiche ? (
                      <a
                        href={selectedSeminaire.fiche}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fiche-button"
                      >
                        FICHE TECHNIQUE
                      </a>
                    ) : (
                      <button className="fiche-button">FICHE TECHNIQUE</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-icon">🔍</div>
              <h3>Aucun espace de séminaire disponible</h3>
              <p>Revenez bientôt pour découvrir nos espaces</p>
            </div>
          )}

          {seminaires.length > 1 && (
            <div className="seminaire-thumbnails">
              {seminaires.map((seminaire, index) => (
                <div
                  key={seminaire._id}
                  className={`seminaire-thumbnail ${selectedSeminaire && selectedSeminaire._id === seminaire._id ? "active" : ""}`}
                  onClick={() => handleSelectSeminaire(seminaire, index)}
                >
                  <img
                    src={seminaire.image || "/placeholder.svg"}
                    alt={seminaire.nom}
                    onError={(e) => {
                      e.target.src = `/placeholder.svg?height=80&width=120&text=${seminaire.nom}`
                    }}
                  />
                  <div className="thumbnail-name">{seminaire.nom}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

   
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Contact</h4>
            <p>+216 00 000 000</p>
            <p>info@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Adresse</h4>
            <p>Avenue de la Promenade</p>
            <p>Tunis, Tunisie</p>
          </div>
          <div className="footer-section">
            <h4>Réservations</h4>
            <p>+216 00 000 000</p>
            <p>reservations@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Wi-Fi</h4>
            <p>Réseau: HOTEL_GUEST</p>
            <p>Mot de passe: Disponible à la réception</p>
          </div>
          <div className="footer-section">
            <h4>Suivez-nous</h4>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="#" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href="#" aria-label="Twitter">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            © {new Date().getFullYear()} Hotel Tunis. Tous droits réservés.
            <br />
            Créé par{" "}
            <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/SolutionHotel/images/itbafa_logo_white.png"
                alt="ITBAFA Logo"
                style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
              />
            </a>
          </p>
        </div>
      </footer>
      {showModal && (
  <div className="modal-backdrop">
    <div className="modal">
      <h2>Réserver une salle</h2>
      <input
        type="text"
        placeholder="Nom"
        value={reservationData.name}
        onChange={(e) => setReservationData({ ...reservationData, name: e.target.value })}
        required
      />
      <input
        type="email"
        placeholder="Email"
        value={reservationData.email}
        onChange={(e) => setReservationData({ ...reservationData, email: e.target.value })}
        required
      />
      <input
        type="tel"
        placeholder="Numéro de téléphone"
        value={reservationData.phoneNumber}
        onChange={(e) => setReservationData({ ...reservationData, phoneNumber: e.target.value })}
        required
      />
      <input
        type="datetime-local"
        value={reservationData.from}
        onChange={(e) => setReservationData({ ...reservationData, from: e.target.value })}
        required
      />

      <div className="modal-actions">
        <button onClick={handleReservationSubmit}>✅ Réserver</button>
        <button onClick={() => setShowModal(false)}>❌ Annuler</button>
      </div>
    </div>
  </div>
)}

    </div>
  )
}

export default SeminairesClient
